import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import clsx from 'clsx';
import { useTheme } from '../common/providers/DialectThemeProvider';
import { useRoute } from '../common/providers/Router';
import IconButton from '../IconButton';
import { RouteName } from './constants';
function Header(props) {
    const { navigate, current } = useRoute();
    const { colors, textStyles, icons, header, notificationHeader } = useTheme();
    const isSettingsOpen = (current === null || current === void 0 ? void 0 : current.name) === RouteName.Settings;
    const openSettings = () => {
        navigate(RouteName.Settings);
    };
    const openThread = () => {
        if (!props.threadId)
            return;
        navigate(RouteName.Thread, {
            params: { threadId: props.threadId },
        });
    };
    const BackButton = () => (_jsx(IconButton, { icon: _jsx(icons.back, {}), onClick: openThread, className: "dt-mr-2 dt-py-1" }));
    const SettingsButton = () => props.isReady && !isSettingsOpen ? (_jsx(IconButton, { icon: _jsx(icons.settings, {}), onClick: openSettings })) : null;
    const CloseButton = () => (_jsx(IconButton, { icon: _jsx(icons.x, {}), onClick: props.onModalClose }));
    const MasterBackButton = () => props.onBackClick ? (_jsx(IconButton, { icon: _jsx(icons.back, {}), onClick: props.onBackClick, className: "dt-mr-2 dt-py-1" })) : null;
    const headerIcons = (_jsx(_Fragment, { children: _jsxs("div", { className: "dt-flex", children: [_jsx(SettingsButton, {}), _jsx("div", { className: clsx(!props.settingsOnly && 'sm:dt-hidden', 'dt-ml-3'), children: _jsx(CloseButton, {}) })] }) }));
    return (_jsx(_Fragment, { children: _jsxs("div", { className: clsx('dt-flex dt-flex-row dt-items-center dt-justify-between', header, notificationHeader), children: [isSettingsOpen ? (_jsxs("div", { className: "dt-flex dt-flex-row dt-items-center", children: [props.isWeb3Enabled && !props.settingsOnly && _jsx(BackButton, {}), !props.isWeb3Enabled && _jsx(MasterBackButton, {}), _jsx("span", { className: clsx(textStyles.header, colors.accent), children: "Settings" })] })) : (_jsxs(_Fragment, { children: [_jsx(MasterBackButton, {}), _jsx("span", { className: clsx(textStyles.header, colors.accent), children: "Notifications" })] })), headerIcons] }) }));
}
export default Header;
//# sourceMappingURL=Header.js.map